import { Paper, Stack } from '@mui/material';
import { useUploadPDFMutation, useUploadPhotoMutation } from '../features/photo/photoSlice';
import { useCallback } from 'react';
import DropArea from './DropArea';

const PhotoUpload = ({order_id, action_id, onUploaded=null}) => {
  const [ uploadPhoto, {isLoading: isUploading} ] = useUploadPhotoMutation();
  const [ uploadPDF, {isLoading: isUploadingPDF} ] = useUploadPDFMutation();

  const uploadPhotoCallback = useCallback((files) => {
    let file = files[0]
    const reader = new FileReader()
    reader.onabort = () => console.log('file reading was aborted')
    reader.onerror = () => console.log('file reading has failed')
    if(file.path.endsWith(".pdf")) {
      reader.onload = () => {
        const binaryStr = reader.result
        uploadPDF({order_id: order_id, action_id: action_id, data: binaryStr, filename: file.name.split(".")[0]})
        if(onUploaded)
          onUploaded();
      }
    } else {
      reader.onload = () => {
        const binaryStr = reader.result
        
        uploadPhoto({order_id: order_id, action_id: action_id, data: binaryStr})
        if(onUploaded)
          onUploaded();
      }
    }
    reader.readAsArrayBuffer(file)

  })

  return <>
  <Paper style={{padding: 8}} elevation={0}>
  <Stack spacing={1}>
    <DropArea fileHandler={uploadPhotoCallback}/>
  </Stack>
  </Paper>
  </>
}

export default PhotoUpload;